import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import APIClient from "../client";
import cropr from "../../shared/utils/cropr";
import DatasetListItem from "./DatasetListItem";
import gettext from "../../shared/utils/gettext";
import moment from "moment";
import { DataTimeline } from "./shared/DataTimeline";

function OtherView(props) {
  const {
    cropfield,
    toggleMeasurementLayer,
    clearMeasurementLayers,
    selectedMeasurementLayers,
  } = props;
  const did = cropfield && cropfield.get("did");
  const [datasets, setDatasets] = useState();
  const [graphData, setGraphData] = useState();
  const [selectedDs, setSelectedDs] = useState();
  const [collapsed, setCollapsed] = useState(false);
  const [initBrushState, setInitBrushState] = useState();
  useEffect(() => {
    clearMeasurementLayers();
    return clearMeasurementLayers;
  }, [clearMeasurementLayers]);
  useEffect(() => {
    setDatasets(null);
    if (!did) {
      return;
    }
    clearMeasurementLayers();
    setDatasets(null);
    APIClient.post(
      "/api/data/datasets/elasticsearch/_search",
      {
        query: {
          bool: {
            should: [
              {
                term: {
                  "data_set_rois.roi.keyword": did,
                },
              },
            ],
            must_not: [
              {
                terms: {
                  "data_format.keyword": ["n"],
                },
              },
            ],
          },
        },
        size: 1000,
        sort: [
          {
            recording_datetime: "asc",
          },
        ],
      },
      cropr.cloudfarm_oauth_token
    )
      .then((response) => {
        const hits = response.hits.hits.map((h) => h._source);
        if (hits.length === 0) {
          setSelectedDs(null);
          setDatasets([]);
          return;
        }
        const datasetsByDate = hits.reduce((memo, ds) => {
          const unix = moment(ds.recording_datetime).startOf("day").unix();
          if (!memo[unix]) {
            const clazz = determineDsClass(ds);
            const d = {
              unix: unix,
              ds: [ds],
            };
            d[clazz] = 0;
            memo[unix] = d;
          } else {
            memo[unix].ds.push(ds);
          }
          return memo;
        }, {});
        const datasetsData = Object.values(datasetsByDate).sort((a, b) => a.unix - b.unix);
        setSelectedDs(datasetsData[datasetsData.length - 1].ds);
        let start = moment.unix(datasetsData[0].unix).startOf("month");
        let end = moment.unix(datasetsData[datasetsData.length - 1].unix).endOf("month");
        while (start <= end) {
          const unix = start.unix();
          if (!datasetsByDate[unix]) {
            datasetsByDate[unix] = { unix: unix };
          }
          start = start.add(1, "months");
        }
        const gd = Object.values(datasetsByDate).sort((a, b) => a.unix - b.unix);
        const twoYago = moment().subtract(2, "years").unix();
        setInitBrushState({
          startIndex: gd.findIndex((d) => d.unix >= twoYago),
          endIndex: gd.length - 1,
        });
        setGraphData(gd);
        setDatasets(hits);
      })
      .catch((e) => {
        console.error(e);
        cropr.notify("error", gettext("Can't get cloudfarm data for this crop field."));
      });
  }, [clearMeasurementLayers, did]);
  return datasets ? (
    datasets.length ? (
      <>
        <div
          className="bg-white"
          style={{ maxHeight: "calc(100vh - 320px)", overflowY: "scroll", overflowX: "hidden" }}
        >
          {selectedDs.map((ds) => (
            <DatasetListItem
              key={ds.uuid}
              uuid={ds.uuid}
              dataset={ds}
              toggleMeasurementLayer={toggleMeasurementLayer}
              selectedMeasurementLayers={selectedMeasurementLayers.filter(
                (v) => v.dsUuid === ds.uuid
              )}
              selectedCropfields={[did]}
              expanded={true}
            />
          ))}
        </div>
        <div
          className="fixed-bottom bg-transparent pt-3 h-140px"
          style={{
            bottom: collapsed ? "-124px" : "0",
            transition: "all 0.2s ease",
          }}
        >
          <button
            className="btn btn-circle btn-smoke position-absolute"
            style={{ top: "-15px", left: "50%" }}
            onClick={() => setCollapsed(!collapsed)}
          >
            <i className={"far " + (collapsed ? "fa-chevron-up" : "fa-chevron-down")}> </i>
          </button>
          <DataTimeline
            graphData={graphData}
            selectedDs={selectedDs}
            setSelectedDs={setSelectedDs}
            initBrushState={initBrushState}
          />
        </div>
      </>
    ) : (
      <div className="bg-white">
        <div className="alert alert-info pt-2 mt-2">
          {gettext("No other data is available for this location")}
        </div>
      </div>
    )
  ) : (
    <div className="text-center mt-5 mb-5">
      <Spinner animation="border" role="status">
        <span className="sr-only">Loading...</span>
      </Spinner>
    </div>
  );
}

function determineDsClass(ds) {
  if (ds.data_format === "r") {
    return "image";
  } else if (
    ["ISOBUS", "John Deere", "AVR", "Probotiq"].some((e) => ds.data_type.indexOf(e) > -1)
  ) {
    return "machine";
  } else if (
    ["Veris", "Dualem", "LIAB", "Fritzmeier", "PH"].some((e) => ds.data_type.indexOf(e) > -1)
  ) {
    return "sensor";
  } else {
    return "other";
  }
}

export default OtherView;
